import { render, staticRenderFns } from "./YourBadgesTab.vue?vue&type=template&id=d7944cce"
import script from "./YourBadgesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./YourBadgesTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourBadgesTab.vue?vue&type=style&index=0&id=d7944cce&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports